import React from 'react'

function EditBookings() {
  return (
    <div>EditBookings</div>
  )
}

export default EditBookings